import '../main.less';
import React from 'react';
import { Field, reduxForm } from 'redux-form';

import InputField from '../../../../shared/form-elements/input';

const Form = props => {
	const { main_niche, main_sale_model, country_id } = props;
	return (
		<div className="payout-request-matrix-edit-cell-form">
			<form
				className="ui-form payouts-form__main clearfix display-flex"
			>
				<Field
					name='amount'
					component={InputField}
					placeholder={props.intl('Min Payout')}
				/>
				<Field
					name='max_amount'
					component={InputField}
					placeholder={props.intl('Max Payout')}
				/>
				<span
					className="checkbox-submit"
					onClick={props.submitCell.bind(null, { main_niche, main_sale_model, country_id }, props.form )}
				/>
			</form>
		</div>
	);
};

export default reduxForm({})(Form);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payout-requests/components/forms/edit-single-matrix-value/main.js